<template>
  <a-modal
    :visible="visible"
    :width="800"
    :footer="null"
    @cancel="$emit('close')"
    class="stats-modal"
  >
    <template #title>
      <div class="title-text">
        <a-icon type="bar-chart" style="margin-right: 8px" />
        <span>{{ labels.title }}</span>
      </div>
    </template>
    <div class="stats-carousel">
      <div class="stats-carousel-list" ref="carouselList">
        <template v-if="loading">
          <div class="loading-spinner">
            <a-spin size="large" :tip="labels.loading" />
          </div>
        </template>
        <template v-else>
          <template v-if="dataSource.length > 0">
            <div
              class="stats-carousel-item"
              v-for="(stat, index) in dataSource"
              :key="index"
              :ref="`carouselItem${index}`"
            >
              <div class="stats-carousel-details-item__logo">
                <img
                  :src="stat.lottery.logo"
                  alt="Loteria"
                  class="lottery-logo"
                />
              </div>
              <div class="stats-carousel-details">
                <p class="stats-carousel-details-lottery">
                  {{ stat.lottery.name }}
                </p>
                <div class="stats-carousel-details-container">
                  <div class="stats-carousel-details-container-item">
                    <span class="stats-carousel-details-container-item-hot">
                      <font-awesome-icon
                        :icon="['fa', 'fire-alt']"
                        class="anticon stats-carousel-details-container-item-hot-icon"
                      />
                      {{ labels.hotNumbers }}
                    </span>
                    <span class="stats-carousel-details-container-item-numbers">
                      <span
                        v-for="(num, idx) in stat.hotNumbers"
                        :key="idx"
                        :class="{
                          clickable: true,
                          disabled: loading,
                        }"
                        @click="
                          addNumbersToPlay({
                            numbers: num,
                            lottery: stat.lottery,
                          })
                        "
                      >
                        {{ num }}
                      </span>
                    </span>
                  </div>
                  <div class="stats-carousel-details-container-item">
                    <span class="stats-carousel-details-container-item-cold">
                      <font-awesome-icon
                        :icon="['fa', 'snowflake']"
                        class="anticon stats-carousel-details-container-item-cold-icon"
                      />
                      {{ labels.coldNumbers }}
                    </span>
                    <span class="stats-carousel-details-container-item-numbers">
                      <span
                        :class="{
                          clickable: true,
                          disabled: loading,
                        }"
                        @click="
                          addNumbersToPlay({
                            numbers: num,
                            lottery: stat.lottery,
                          })
                        "
                        v-for="(num, idx) in stat.coldNumbers"
                        :key="idx"
                      >
                        {{ num }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="no-stats">
            <a-empty :description="labels.noData" />
          </div>
        </template>
      </div>
      <!-- controls left right -->
      <div v-if="dataSource.length > 2" class="controls">
        <font-awesome-icon
          @click="prevAction"
          :icon="['fa', 'chevron-left']"
          class="icon-large"
        />
        <font-awesome-icon
          @click="nextAction"
          :icon="['fa', 'chevron-right']"
          class="icon-large"
        />
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { PLAY_TYPES } from "../utils/utils";
import { _ } from "core-js";

export default {
  name: "StatsModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
    lotteries: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      scrollInterval: null,
      isHovered: false,
      amount: 1,
      amountError: null,
      lotteriesError: null,
      selectedIds: [],
      selectedLotteries: [],
    };
  },
  emits: ["close", "addNumbersToPlay"],
  mounted() {
    this.handleFetchStats();
  },
  computed: {
    ...mapState({
      screenWidth: "layout/screenWidth",
    }),
    isMobile() {
      return this.screenWidth <= 600;
    },
    itemWidth() {
      const items = this.dataSource.length;
      const itemWidth = this.isMobile ? 320 : 365;
      return (items * itemWidth + (items - 1) * 20) / items;
    },
  },
  methods: {
    ...mapActions({
      fetchStats: "orders/fetchStats",
    }),
    close() {
      this.$emit("close");
    },
    async handleFetchStats() {
      if (this.loading) return;
      try {
        this.loading = true;
        const { data: stats = [] } = await this.fetchStats();
        this.dataSource = stats;
        // this.$nextTick(() => {
        //   if (this.dataSource.length > 0) this.handleInitScroll();
        //   else this.handleStopScroll();
        // });
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        this.loading = false;
      }
    },
    nextAction() {
      const list = this.$refs.carouselList;
      if (list.scrollLeft + list.clientWidth < list.scrollWidth) {
        list.scrollLeft += this.itemWidth + 2;
      } else {
        list.scrollLeft = 0;
      }
    },
    prevAction() {
      const list = this.$refs.carouselList;
      if (list.scrollLeft > 0) {
        list.scrollLeft -= this.itemWidth + 2;
      } else {
        list.scrollLeft = list.scrollWidth - list.clientWidth;
      }
    },
    autoScroll() {
      const list = this.$refs.carouselList;
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
        list.scrollLeft = 0;
      } else {
        list.scrollLeft += this.itemWidth + 2;
      }
    },
    handleInitScroll() {
      if (this.isHovered) {
        this.isHovered = false;
      }
      this.autoScroll();
      this.scrollInterval = setInterval(this.autoScroll, 3000);
    },
    handleStopScroll() {
      if (this.isHovered) return;
      this.isHovered = true;
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    addNumbersToPlay({ lottery, ...play }) {
      try {
        const foundLotteryIndex = this.lotteries.findIndex(
          (lot) => lot.id === lottery.id
        );
        if (foundLotteryIndex !== -1) {
          this.selectedIds = [
            _.cloneDeep(this.lotteries)[foundLotteryIndex]?.id,
          ];
        }
        // MODAL TO ASK FOR AMOUNT
        this.$confirm({
          class: "confirm-play-modal",
          title: this.labels.confirmPlay.title,
          content: (h) =>
            h(
              "div",
              {
                class: "confirm-play-content",
              },
              [
                h("p", {
                  domProps: {
                    innerHTML: this.labels.confirmPlay.subtitle.replace(
                      "{numbers}",
                      play.numbers
                    ),
                  },
                }),
                h(
                  "a-form-item",
                  {
                    props: {
                      label: this.labels.confirmPlay.lotteries.label,
                      labelCol: { span: 24 },
                      style: { width: "100%" },
                      ...(this.lotteriesError
                        ? {
                            validateStatus: "error",
                            help: this.lotteriesError,
                          }
                        : {}),
                    },
                  },
                  [
                    h(
                      "a-select",
                      {
                        props: {
                          mode: "multiple",
                          placeholder:
                            this.labels.confirmPlay.lotteries.placeholder,
                          defaultValue: this.selectedIds,
                          allowClear: true,
                          showSearch: true,
                          optionFilterProp: "children",
                          class: "lotteries-select",
                        },
                        style: { width: "100%" },
                        on: {
                          change: (value) => {
                            this.selectedIds = value;
                            this.lotteriesError = null;
                          },
                        },
                      },
                      this.lotteries.map((lottery) =>
                        h(
                          "a-select-option",
                          {
                            key: lottery.id,
                            attrs: { value: lottery.id, objectvalue: lottery },
                          },
                          lottery.name
                        )
                      )
                    ),
                  ]
                ),
                h(
                  "a-form-item",
                  {
                    props: {
                      label: this.labels.confirmPlay.amount.label,
                      labelCol: { span: 24 },
                      ...(this.amountError
                        ? {
                            validateStatus: "error",
                            help: this.amountError,
                          }
                        : {}),
                    },
                  },
                  [
                    h("a-input-number", {
                      props: {
                        placeholder: this.labels.confirmPlay.amount.placeholder,
                        defaultValue: this.amount,
                        allowClear: true,
                        min: 1,
                        autoFocus: true,
                        precision: 0,
                        step: 1,
                      },
                      on: {
                        change: (value) => {
                          this.amount = value;
                          this.amountError = null;
                        },
                      },
                    }),
                  ]
                ),
              ]
            ),
          okText: this.labels.confirmPlay.confirmButtonText,
          okType: "danger",
          icon: "question-circle",
          cancelText: this.labels.confirmPlay.cancelButtonText,
          visible: true,
          okButtonProps: {
            disabled: this.submitting,
            loading: this.submitting,
          },
          onOk: async () => {
            if (!this.selectedIds.length) {
              this.$message.error(this.labels.confirmPlay.lotteries.validation);
              this.lotteriesError =
                this.labels.confirmPlay.lotteries.validation;
              throw new Error("NO_LOTTERIES_SELECTED");
            }
            if (!this.amount || this.amount < 1) {
              this.$message.error(this.labels.confirmPlay.amount.validation);
              this.amountError = this.labels.confirmPlay.amount.validation;
              throw new Error("INVALID_AMOUNT");
            }
            const plays = _.cloneDeep(this.selectedLotteries).map(
              (lottery) => ({
                ...play,
                lottery,
                type: PLAY_TYPES.QUINIELA,
                amount: this.amount,
              })
            );
            this.$emit("addNumbersToPlay", plays);
            this.amount = 1;
            this.selectedIds = [];
            this.amountError = null;
            this.lotteriesError = null;
          },
        });
      } catch (error) {
        if (
          error.message.includes("INVALID_AMOUNT") ||
          error.message.includes("NO_LOTTERIES_SELECTED")
        )
          return;
        console.error("Error adding numbers to play:", error);
      }
    },
  },
  watch: {
    selectedIds: {
      handler(newVal = []) {
        this.selectedLotteries = newVal.map((id) =>
          _.cloneDeep(this.lotteries).find((lottery) => lottery.id === id)
        );
      },
      immediate: true,
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.stats-modal {
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    border-radius: 0;
    border: 1px solid var(--modal-shadow) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow) !important;
  }
  .ant-modal-header {
    background-color: transparent;
    border-color: var(--text-active);
    .title-text {
      color: var(--text-active);
      font-size: 18px;
      .anticon {
        color: var(--text-active);
      }
    }
  }
  .ant-modal-close {
    color: var(--text) !important;
    &:hover {
      color: var(--text-active) !important;
    }
  }

  .stats-carousel-list {
    position: relative;
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;
    .stats-carousel-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: var(--card-bg);
      box-shadow: var(--card-bg);
      border: 1px solid var(--card-shadow);
      border-radius: 10px;
      padding: 15px;
      width: 365px;
      min-width: 365px;
      @media (max-width: 600px) {
        width: 320px;
        min-width: 320px;
      }
      .stats-carousel-details-item__logo {
        display: flex;
        justify-content: center;
        img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
      }
      .stats-carousel-details {
        text-align: center;
        h2 {
          color: var(--text);
          font-size: 18px;
          margin-bottom: 5px;
        }
        &-lottery {
          color: var(--text);
          font-size: 18px;
          margin-bottom: 10px;
          font-weight: 500;
        }
        &-container {
          display: flex;
          flex-direction: row;
          gap: 10px;
          margin-top: 10px;
          &-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            &-hot,
            &-cold {
              font-weight: 600;
              color: var(--text);
              margin-bottom: 5px;
              display: flex;
              align-items: center;
              .anticon {
                margin-right: 5px;
              }
            }
            & .stats-carousel-details-container-item-hot-icon {
              color: var(--danger);
            }
            & .stats-carousel-details-container-item-cold-icon {
              color: var(--info);
            }
            &-numbers {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 5px;
              span {
                font-family: "Exo 2", sans-serif;
                font-weight: 400;
                margin: 0;
                line-height: 1.3;
                font-size: 1rem;
                text-align: center;
                color: var(--text);
                font-size: 1.2rem;
                padding: 8px;
                background-color: var(--stats-item-number);
                border-radius: 0.85rem;
                &.clickable {
                  cursor: pointer;
                  transition: all 0.3s ease;
                  &:hover {
                    background-color: var(--btn-bg-primary);
                    color: var(--btn-text-primary);
                    transform: scale(1.1);
                  }
                }
                &.disabled {
                  pointer-events: none;
                  opacity: 0.6;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }
    .no-stats {
      width: 100%;
      text-align: center;
      color: var(--text-muted);
      font-size: 16px;
      padding: 20px;
    }
    .loading-spinner {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100px;
      :deep(.ant-spin-text) {
        color: var(--text) !important;
      }
      :deep(.ant-spin-dot-item) {
        background-color: var(--text) !important;
      }
    }
  }
  .controls {
    position: absolute;
    width: 94%;
    display: flex;
    justify-content: space-between;
    top: 50%;
    pointer-events: none;
    @media (max-width: 600px) {
      width: 88%;
    }
    .icon-large {
      font-size: 24px;
      color: var(--text);
      cursor: pointer;
      pointer-events: auto;
      &:hover {
        color: var(--success);
      }
    }
  }
}
.confirm-play-modal {
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    border-radius: 0;
    border: 1px solid var(--modal-shadow) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow) !important;
  }
  .ant-modal-header {
    background-color: transparent;
    border-color: var(--text-active);
    .title-text {
      color: var(--text-active);
      font-size: 18px;
      .anticon {
        color: var(--text-active);
      }
    }
  }
  .ant-modal-confirm-title {
    color: var(--text);
  }
  .ant-modal-close {
    color: var(--text) !important;
    &:hover {
      color: var(--text-active) !important;
    }
  }
  .confirm-play-content {
    p {
      color: var(--text);
      margin-bottom: 20px;
      font-size: 16px;
    }
    .ant-form-item-label > label {
      color: var(--text);
      font-weight: 600;
    }
    .ant-input-number {
      width: 100%;
    }
    .ant-input-number:hover,
    .ant-input-number-focused {
      border-color: var(--primary) !important;
      box-shadow: 0 0 0 2px var(--primary-shadow) !important;
    }
    .ant-input-number::placeholder {
      color: var(--text-muted) !important;
      opacity: 1 !important;
    }
  }
}
::v-deep .ant-select-selection--multiple {
  background-color: var(--input-bg) !important;
  .ant-select-selection__choice {
    background-color: var(--input-bg) !important;
    border-color: var(--text-muted) !important;
    color: var(--text) !important;
    .anticon-close {
      color: var(--text) !important;
    }
  }
}
::v-deep .ant-input-number {
  background-color: var(--input-bg);
  border: 1px solid var(--text-muted);
  color: var(--text);
}
</style>
